import { render } from "./Synergy.vue?vue&type=template&id=87766790&scoped=true"
import script from "./Synergy.vue?vue&type=script&lang=js"
export * from "./Synergy.vue?vue&type=script&lang=js"

import "./Synergy.vue?vue&type=style&index=0&id=87766790&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87766790"]])

export default __exports__